import { render, staticRenderFns } from "./table-change.vue?vue&type=template&id=54bf22ec&scoped=true"
import script from "./table-change.vue?vue&type=script&lang=js"
export * from "./table-change.vue?vue&type=script&lang=js"
import style0 from "./table-change.vue?vue&type=style&index=0&id=54bf22ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf22ec",
  null
  
)

export default component.exports